<template>
    <div class="section">
        <div class="columns">
            <div class="column is-one-quarter">
                <ListAside
                :selectedOrdering="ordering"
                :categoriesUrl="categoriesUrl"
                :availableFilters="availableFilters"
                :selectedFiltersList="selectedFiltersActualList"
                @updatedFilter="onFilterChange"
                @changedOrder="onOrderChange"/>
            </div>
            <div class="column is-three-quarters-desktop is-full-touch">
                <div class="columns is-multiline is-mobile">
                    <Product 
                    v-for="prod in products"
                    :cartItemUrl="cartItemUrl"
                    :addFromCatalog="addFromCatalog"
                    :product="prod" 
                    :key="prod.id"
                    :primaryColor="primaryColor"
                    :blackText="blackText"/>
                </div>
                
            </div>   
        </div>
        <div class="columns">
            <div class="column is-full">
                <div class="p-top-30">
                    <b-pagination
                        :total="count"
                        :per-page="perPage"
                        :current.sync="actualPage"
                        :range-before="2"
                        :rounded="true"
                        :range-after="2"
                        order="is-centered"
                        @change="onPageChange"
                        icon-prev="chevron-left"
                        icon-next="chevron-right"
                    >
                    </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Product from "./components/Product.vue"
import ListAside from "./components/ListAside.vue"
import {getHandler} from "./../../../services/http.js"
export default {
    components:{
        Product,
        ListAside
    },
    props:{
        page:{
            type:String,
            default:1
        },
        ordering:{
            type:String,
            default:"price"
        },
        category:{
            type:String,
            default:""
        },
        subcategory:{
            type:String,
            default:""
        },
        listUrl:{
            type:String,
            default:""
        },
        primaryColor:{
            type:String,
            default:""
        },
        blackText:{
            type:String,
            default:""
        },
        listTemplate:{
            type:String,
            default:""
        },
        categoriesUrl:{
            type:String,
            default:""
        },
        filterListUrl:{
            type:String,
            default:""
        },
        selectedFilterList:{
            type:String,
            default:false
        },
        cartItemUrl:{
            type:String,
            default:""
        },
        addFromCatalog:{
            type:String,
            default:""
        }

    },
    data(){
        return{
            products:[],
            loadingList:false,
            count:0,
            perPage:24,
            actualPage:parseInt(this.page),
            selectedOrdering:"",
            availableFilters:[]
        }
    },
    methods:{
        async fetchProducts(){
            if (!this.subcategory.length){
                this.subcategory = ""
            }
            if(this.selectedFilterList){
                var rightFilterVal = this.selectedFilterList
            } else{
                var rightFilterVal = ''
            }
            
            var url = `${this.listUrl}?cat_slug=${this.category}&sub_slug=${this.subcategory}&page=${this.page}&public_only=TRUE&ordering=${this.ordering}&filter_options=${rightFilterVal}`
            this.loadingList = true
            var resp = await getHandler(url, {error:false, success:false})
            this.products = resp.results
            this.count = resp.count
            this.loadingList = false
        },
        async fetchFilters(){
            if(!this.category.length){
                this.category = ""
            }
            if(!this.subcategory.length){
                this.subcategory = ""
            }
            var url = `${this.filterListUrl}?category=${this.category}&subcategory=${this.subcategory}&pagina_size=10000`
            var resp = await getHandler(url, {error:false, success:false})
            this.availableFilters = resp.results
        },
        onPageChange(page){
            var url = this.listTemplate + "&page=" + page + "&ordering=" + this.ordering + "&filter_options=" + this.selectedFilterList
            window.location.replace(url)
        },

        onOrderChange(val){
            this.selectedOrdering=val
            
            var url = this.listTemplate + "&page=" + this.page + "&ordering=" + this.selectedOrdering + "&filter_options=" + this.selectedFilterList
            window.location.replace(url)
        },

        onFilterChange(options){
            console.log("Opciones", options)
            var rightOptions = String(options)
            var url = this.listTemplate + "&page=" + this.page + "&ordering=" + this.selectedOrdering + "&filter_options=" + rightOptions
            window.location.replace(url)
        }

    },
    watch:{
        ordering: function (val){
            this.selectedOrdering = val
        }
    },
    computed:{
        selectedFiltersActualList(){
            if(this.selectedFilterList){
                var listed =  this.selectedFilterList.split(',')
                var filtered = listed.filter((el)=>{
                    return !['',null,'None'].includes(el)
                })
                console.log(filtered)
                return filtered
            }
        }
    },
    created(){
        this.fetchProducts()
        this.fetchFilters()
    }

}
</script>

